import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Entidad,TipoEntidad } from '../../../../interfaces/entidad';
import { ContactoService } from '../../../../providers/contacto.service';
import { PersonasService } from '../../../../providers/personas.service';
import { FormControl } from '@angular/forms';
import { EntidadService } from '../../../../providers/entidad.service';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-asignar-contacto-dialog',
  templateUrl: './asignar-contacto-dialog.component.html',
  styleUrls: ['./asignar-contacto-dialog.component.scss']
})
export class AsignarContactoDialog implements OnInit{
  public entidadesFiltroCtrl: FormControl = new FormControl();
  public entidadesFiltradas: ReplaySubject<Entidad[]> = new ReplaySubject<Entidad[]>(1);
  entidad_id: any = -1;
  error: string = '';
  cargando:boolean = false;
  entidades: any[] = [];
  private debounceTimer: any;

  constructor(
    public dialogEliminar: MatDialogRef<AsignarContactoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _personasSv: PersonasService,
    private _contactoSv: ContactoService,
    private entidadService: EntidadService,

  ) { 

    // console.log(this.data);
    this.entidad_id = this.data.contacto.entidad.Id_Entidad
    // console.log(this.entidad_id);
    
  }

  ngOnInit(): void {
    this.traerEntidades(null);
       // cuando cambia el valor del buscador, filtramos
       this.entidadesFiltroCtrl.valueChanges.subscribe(() => {      
        this.filtrarEntidades();
      });
  }


  /**
   * Traemos las entidades para mostrarlas en la carga
   */
  traerEntidades(filtro): void {
    this.entidades = [];
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 200
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        razonSocial: filtro
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion,
              },
              observacion: prospecto.observacion
            });
          });
          // actualizar opciones del filtro
          //this.filtrarEntidades();
        }
      },
      error => {

      }
    );
  }
  private filtrarEntidades() {
    if (this.entidadesFiltroCtrl.value.length <= 2) {
      return;
      
    }

     if (this.debounceTimer) {
       clearTimeout(this.debounceTimer);
    }
     this.debounceTimer = setTimeout(() => {
      const search = this.entidadesFiltroCtrl.value;
      // console.log(search);
      this.traerEntidades(search);
      this.entidadesFiltradas.next(this.entidades.slice());
      this.debounceTimer = null;
    }, 600);
    //vER POR QUE LIMPIA EL CAMPO ENTIDAD Y SI CON ESO SE SOLUCIONA EL PROBLEMA DE FONDO
    
  }

 

  onInput(){
    this.error = '';
  }

  onCancelar(): void {
    this.dialogEliminar.close();
  }


  

  onEliminar(): void {
    
    if(!this.entidad_id){
      this.error = 'Tienes que elegir un Prospecto/Cliente';
      return
    }
    
    this._contactoSv.asignarContacto(this.entidad_id.IdEntidad, this.data.contacto.IdContacto).subscribe(
      respuesta =>{
        if(respuesta.estado == 1){
          this.dialogEliminar.close(respuesta.mensaje);
        }else{
          this.error = respuesta.mensaje;
        }
      },
      (er) => {
        this.error = er; // ocultar progress bar si se estaba mostrando
      }
    )



  }
}
